module.exports = __webpack_public_path__ + "static/assets/e1f6c5e7d686336bc412de60221f076c.png";